import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ErrorAlert } from '@/components/ErrorAlert';
import { TimeDisplay } from '@/components/TimeDisplay';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { ColorBadge } from '@/components/ui+/ColorBadge';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/a/workflows/')({
  component: Component,
});

function Component() {
  const { data: workflows, isPending, isError, error } = useQuery(api.workflows.list);

  if (isPending) {
    return <LoadingIcon className="mx-auto mt-8" />;
  }
  if (isError) return <ErrorAlert message={error.message} title="Error loading workflows" />;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Workflows</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Actions</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Created</TableHead>
              <TableHead>Updated</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {
              // @ts-expect-error
              workflows?.map((workflow) => (
                <TableRow key={workflow._id}>
                  <TableCell>
                    <Link
                      to="/a/workflows/$workflowId"
                      params={{ workflowId: workflow._id }}
                      className="text-primary hover:underline"
                    >
                      View
                    </Link>
                  </TableCell>
                  <TableCell>{workflow.name || '-'}</TableCell>
                  <TableCell>
                    {(() => {
                      if (!workflow.runResult) {
                        return <ColorBadge color="blue">IN PROGRESS</ColorBadge>;
                      }
                      const status = workflow.runResult.kind.toUpperCase();
                      const color =
                        workflow.runResult.kind === 'failed'
                          ? 'red'
                          : workflow.runResult.kind === 'success'
                            ? 'green'
                            : 'gray';
                      return <ColorBadge color={color}>{status}</ColorBadge>;
                    })()}
                  </TableCell>
                  <TableCell>
                    <TimeDisplay timestamp={workflow._creationTime} showTime={false} />
                  </TableCell>
                  <TableCell>
                    <TimeDisplay
                      timestamp={workflow.startedAt || workflow._creationTime}
                      showTime={false}
                    />
                  </TableCell>
                </TableRow>
              ))
            }
            {!workflows?.length && (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-4">
                  No workflows found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
